export default {
  user: {
    list: 'User List',
    search: {
      quickSearch: 'Quick Search',
      placeholder: 'Phone/Email/Nickname/Real Name',
      roles: 'Roles',
      registerTime: 'Register Time'
    },
    group: {
      all: 'All',
      admin: 'Admin',
      user: 'User',
      guest: 'Guest'
    },
    fields: {
      id: 'ID',
      name: 'Name',
      contact: 'Contact',
      phone: 'Phone',
      email: 'Email',
      realname: 'Real Name',
      roles: 'Roles',
      createdAt: 'Created At',
      unnamed: 'Unnamed'
    },
    detail: {
      basicInfo: 'Basic Information',
      contactInfo: 'Contact Information',
      roleInfo: 'Role Information',
      labels: {
        userName: 'User Name',
        userId: 'User ID',
        phone: 'Phone',
        email: 'Email',
        createdAt: 'Created At',
        updatedAt: 'Updated At'
      }
    },
    form: {
      labels: {
        email: 'Email',
        name: 'Name',
        phone: 'Phone',
        password: 'Password',
        passwordConfirmation: 'Confirm Password',
        roles: 'Roles'
      },
      placeholders: {
        email: 'Please enter email',
        name: 'Please enter name',
        phone: 'Please enter phone',
        password: 'Please enter password',
        passwordConfirmation: 'Please confirm password',
        roles: 'Please select roles'
      },
      validation: {
        email: {
          required: 'Please enter email',
          invalid: 'Please enter a valid email address'
        },
        name: {
          required: 'Please enter name'
        },
        phone: {
          required: 'Please enter phone',
          invalid: 'Please enter a valid phone number'
        },
        password: {
          required: 'Please enter password',
          minLength: 'Password must be at least 6 characters'
        },
        passwordConfirmation: {
          required: 'Please confirm password',
          notMatch: 'Passwords do not match'
        },
        roles: {
          required: 'Please select roles'
        }
      }
    }
  },
  role: {
    list: 'Role List',
    search: {
      quickSearch: 'Quick Search',
      placeholder: 'Role Name/Description'
    },
    fields: {
      name: 'Role Name',
      permissions: 'Permissions',
      type: 'Type',
      createdAt: 'Created At'
    }
  },
  aigc: {
    agent: {
      list: 'Agent List',
      add: 'New Agent',
      search: {
        quickSearch: 'Quick Search',
        placeholder: 'Agent Name/Description',
        type: 'Type',
        selectType: 'Please select type',
        createdAt: 'Created At'
      },
      fields: {
        basic: 'Basic Info',
        provider: 'Provider',
        model: 'Model',
        type: 'Type',
        name: 'Name',
        createdAt: 'Created At'
      },
      provider: 'Provider',
      model: 'Model',
      name: 'Name',
      namePlaceholder: 'Please enter name',
      nameRequired: 'Please enter name',
      gender: 'Gender',
      genderPlaceholder: 'Please select gender',
      genderRequired: 'Please select gender',
      genders: {
        male: 'Male',
        female: 'Female',
        neutral: 'Neutral'
      },
      providers: {
        all: 'All',
        spark: 'iFlytek Spark',
        openai: 'OpenAI',
        anthropic: 'Anthropic',
        google: 'Google'
      },
      models: {
        generalv3: 'Spark Large Language Model V3.0',
        'gpt-4': 'GPT-4',
        'gpt-4-turbo': 'GPT-4 Turbo',
        'gpt-3.5-turbo': 'GPT-3.5 Turbo',
        'claude-3-opus': 'Claude 3 Opus',
        'claude-3-sonnet': 'Claude 3 Sonnet',
        'claude-2.1': 'Claude 2.1',
        'gemini-pro': 'Gemini Pro',
        'gemini-ultra': 'Gemini Ultra'
      },
      selectProvider: 'Please select provider',
      selectModel: 'Please select model',
      prompt: 'Prompt Settings',
      promptRequired: 'Please enter prompt',
      promptPlaceholder: 'Please enter the prompt settings for the AI assistant, which will determine its behavior and personality...'
    },
    tag: {
      list: 'Tag List',
      add: 'New Tag',
      edit: 'Edit Tag',
      fields: {
        name: 'Name',
        taggingsCount: 'Usage Count'
      },
      namePlaceholder: 'Please enter tag name',
      nameRequired: 'Please enter tag name'
    }
  },
  home: {
    dashboard: {
      stats: {
        totalUsers: 'Total Users',
        activeToday: 'Active Today',
        totalRevenue: 'Total Revenue',
        conversionRate: 'Conversion Rate',
        comparedToLastWeek: 'vs last week'
      },
      charts: {
        visitTrend: 'Visit Trend',
        userDistribution: 'User Distribution',
        timeRanges: {
          week: 'This Week',
          month: 'This Month',
          year: 'This Year'
        },
        distributionTypes: {
          type: 'Type',
          region: 'Region'
        },
        userTypes: {
          newUsers: 'New Users',
          activeUsers: 'Active Users',
          inactiveUsers: 'Inactive Users'
        },
        regions: {
          east: 'East China',
          north: 'North China',
          south: 'South China',
          west: 'West China',
          northeast: 'Northeast China'
        },
        weekdays: {
          monday: 'Mon',
          tuesday: 'Tue',
          wednesday: 'Wed',
          thursday: 'Thu',
          friday: 'Fri',
          saturday: 'Sat',
          sunday: 'Sun'
        },
        chartLabels: {
          visits: 'Visits',
          userDistribution: 'User Distribution'
        }
      },
      activities: {
        title: 'Recent Activities',
        viewAll: 'View All',
        noActivities: 'No activities yet'
      }
    }
  },
  common: {
    operation: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    search: 'Search',
    reset: 'Reset',
    loading: 'Loading...',
    noData: 'No Data',
    success: 'Operation Successful',
    error: 'Operation Failed',
    deleteConfirm: 'Are you sure you want to delete?',
    total: 'Total {total} items',
    basicInfo: 'Basic Information',
    contactInfo: 'Contact Information',
    close: 'Close',
    submit: 'Submit',
    required: 'Required',
    pleaseSelect: 'Please select',
    pleaseInput: 'Please input'
  },
  menu: {
    users: 'User Management',
    roles: 'Role Management',
    agents: 'Agent Management'
  },
  permissions: {
    menu: {
      aigc_agents: {
        destroy: 'Delete Agent',
        run: 'Run Agent',
        stop: 'Stop Agent'
      },
      sys_users: {
        destroy: 'Delete User'
      }
    }
  }
}
